// import SmallBanner from '@components/competitions/free-class-banner/mobileViewBanner'
import { TRIAL_CLASS_BANNER_REDIRECT_LINK } from '@common/constants'
import { CClient } from '@common/utils'
import FastComments from '@components/common/fast-comments'
// import FastComments from '@components/common/fast-comments'
import Footer from '@components/common/footer'
import { FastlyImage, LazyAPIImage } from '@components/common/image'
import NavBar from '@components/common/navbar'
import RenderRichTextContent from '@components/common/render-rich-text-content'
import Section, { SectionTitle } from '@components/common/section'
import AlgoPhoneBanner from '@components/competitions/algo-class-banner/algo-mobile-view-banner'
import AlgoLongBanner from '@components/competitions/algo-class-banner/side-banner-for-algo'
import CompetitionCta from '@components/competitions/competition-cta'
import CompetitionPageBanner from '@components/competitions/free-class-banner/competition-page-banner'
import QuizBanner from '@components/competitions/quiz-banner'
import RecommendedCompetitions from '@components/competitions/recommended-competition'
import ReferralBanner from '@components/competitions/referral-banner'
import AuthModal from '@containers/competitions/auth-modal.dynamic'
import { useSessionContext } from '@contexts/session'
import { USER_COUNTRY_FROM_IP_COOKIE } from '@lib/constants/common'
import {
  competitionDetailsPageDefaultMetaImageUrl,
  COMPETITION_PAGE_UTM_PARAM,
  COMPETITION_TYPES,
  // FASTCOMMENTS_TENANT_ID,
  threeMemberTeamCompetitions,
  HPE_CODEWARS_2025_SLUGS,
} from '@lib/constants/competitions'
import { competitionsListSeo } from '@lib/seo'
import {
  CompetitionEventDetailsProps,
  CompetititonsListType,
  PhaseType,
} from '@lib/types/competitions'
import {
  formatCountryQuery,
  getCountryFromIP,
  redirectToForGetInitialProps,
} from '@lib/utils/common'
import { getDimensions } from '@lib/utils/competitions'
import { getDifference } from '@lib/utils/date-utils'
import date, {
  formatTimeByTimezone,
  SYSTEM_TIMEZONE,
  TIME_FORMAT_TZ,
} from '@lib/utils/date.utils'
// import { FastCommentsCommentCountWidget } from 'fastcomments-react'
import { NextPage } from 'next'
import { NextSeo } from 'next-seo'
import Head from 'next/head'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { parseCookies } from 'nookies'
import { useEffect, useState } from 'react'
import { Facebook, Linkedin, Twitter } from 'react-feather'
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from 'react-share'

const COMMENTS_SECTION_REF = 'comments'
const SECTION_TOP_OFFSET_FOR_SCROLL = 80
const ALGO_COURSES_URL =
  'https://www.codingal.com/courses/ioi-algorithms-course/?course=algorithms&utm_source=code-battle-thank-you-page/'

type Props = {
  competitionDetails: CompetitionEventDetailsProps
  isUpcoming: boolean
  isOngoing: boolean
  ended: boolean
  isSubmissionDone: boolean
  isReferralCampaign: boolean
  phaseType: PhaseType
  liveCompetitions: CompetititonsListType
}

const Competition: NextPage<Props, {}> = ({
  competitionDetails,
  isUpcoming,
  isOngoing,
  ended,
  isSubmissionDone,
  isReferralCampaign,
  liveCompetitions,
}) => {
  const [headerHeight, setHeaderHeight] = useState(0)
  const [isScrollHeader, setIsScrollHeader] = useState(false)
  const [isNormalHeader, setIsNormalHeader] = useState(true)
  const router = useRouter()
  const {
    slug,
    isRegistered,
    id: competitionId,
    metaTitle,
    metaDescription,
    ogDescription,
    ogImage,
    title,
    headerImage,
    organizer,
    start,
    end,
    sections,
    location,
  } = competitionDetails
  const [authRedirectionUrl, setAuthRedirectionUrl] = useState(
    `/competitions/${slug}/register`
  )
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false)
  const [nextRegisterRedirect, setNextRegisterRedirect] = useState('')

  const { loggedIn, timezone, isPaidUser, name } = useSessionContext()
  const [visibleSection, setVisibleSection] = useState('')
  const competitionUrl = `https://codingal.com/competitions/${slug}`
  const checkedTimezone = timezone ? timezone : SYSTEM_TIMEZONE

  const sectionRefs = sections.map((section) => section.slug)
  sectionRefs.push(COMMENTS_SECTION_REF)

  useEffect(() => {
    window.scrollTo(0, 0)

    const mainContainerDiv: HTMLElement = document.querySelector(
      '#main-container'
    )
    const mainContainerPosition = mainContainerDiv.offsetTop
    const headerChangeOffset = 0.3 * mainContainerPosition

    window.addEventListener('scroll', function () {
      if (window.pageYOffset >= mainContainerPosition + headerChangeOffset) {
        setIsScrollHeader(true)
        setIsNormalHeader(false)
      }
      if (window.pageYOffset < mainContainerPosition) {
        setIsNormalHeader(true)
        setIsScrollHeader(false)
      }
    })
    // getSSOConfig()
  }, [])

  useEffect(() => {
    if (isNormalHeader) {
      const normalHeader: HTMLElement = document.querySelector('#normalHeader')
      setHeaderHeight(normalHeader.clientHeight)
    }
    if (isScrollHeader) {
      const scrollHeader: HTMLElement = document.querySelector('#scrollHeader')
      setHeaderHeight(scrollHeader.clientHeight)
    }
  }, [isNormalHeader, isScrollHeader])

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition =
        window.scrollY + headerHeight + SECTION_TOP_OFFSET_FOR_SCROLL

      const selectedSection = sectionRefs.find((section) => {
        const element = document.getElementById(section)
        if (element) {
          const { offsetBottom, offsetTop } = getDimensions(element)
          return scrollPosition > offsetTop && scrollPosition < offsetBottom
        }
      })

      if (selectedSection !== visibleSection) {
        setVisibleSection(selectedSection)
      } else if (!selectedSection && visibleSection) {
        setVisibleSection('')
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [visibleSection])

  const handleScroll = (sectionSlug: string) => {
    const sectionDiv = document.querySelector(`#${sectionSlug}`)
    window.scrollBy({
      top: sectionDiv.getBoundingClientRect().top - headerHeight,
      behavior: 'smooth',
    })
  }

  const handleRegisterNow = () => {
    if (loggedIn) {
      router.push({
        pathname: `/competitions/${slug}/register`,
        query: router.query,
      })
    } else {
      setIsAuthModalOpen(true)
    }
  }

  const offlineLocation = {
    '@type': 'Place',
    name: location && location.name,
    address: {
      '@type': 'PostalAddress',
      streetAdress: location && location.postalAddress,
      addressLocality: '',
      postalCode: '',
      addressRegion: '',
      addressCountry: '',
    },
  }

  const onlineLocation = {
    '@type': 'VirtualLocation',
    url: competitionUrl,
  }

  const onlineEventAttendanceMode =
    'https://schema.org/OnlineEventAttendanceMode'

  const offlineEventAttendanceMode =
    'https://schema.org/OfflineEventAttendanceMode'

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Event',
    eventStatus: 'https://schema.org/EventScheduled',
    name: title,
    startDate: start,
    endDate: end,
    eventAttendanceMode:
      location.locationType === 'VirtualLocation'
        ? onlineEventAttendanceMode
        : offlineEventAttendanceMode,
    location:
      location.locationType === 'VirtualLocation'
        ? onlineLocation
        : offlineLocation,
    image: [headerImage || competitionDetailsPageDefaultMetaImageUrl],
    description: metaDescription || competitionsListSeo.description,
    offers: {
      '@type': 'Offer',
      availability: 'https://schema.org/InStock',
      price: 0,
      priceCurrency: 'USD',
      url: competitionUrl,
      validFrom: start,
    },
    performer: {
      '@type': 'Person',
      name: name || 'Student',
    },
    organizer: {
      '@type': 'Organization',
      name: organizer?.title || 'Codingal',
      url: organizer?.website || 'https://www.codingal.com/',
    },
  }

  const handleReferralRegister = (slug: string) => {
    setAuthRedirectionUrl(`/competitions/${slug}/invite`)
    setNextRegisterRedirect(`/competitions/${slug}/invite`)
    setIsAuthModalOpen(true)
  }

  useEffect(() => {
    if (loggedIn && isRegistered) setIsAuthModalOpen(false)
  }, [loggedIn])

  useEffect(() => {
    if (!loggedIn && !ended) setIsAuthModalOpen(true)
  }, [])

  const isCodewars = HPE_CODEWARS_2025_SLUGS === slug
  const isHpeCodeBattle = slug === HPE_CODEWARS_2025_SLUGS
  const isThreeMemberTeam = threeMemberTeamCompetitions.includes(slug)

  // Timer for upcoming competitions
  const [timeToStart, settimeToStart] = useState(getDifference(start))
  useEffect(() => {
    const interval = setInterval(() => {
      const difference = getDifference(start)

      if (date().isSameOrAfter(start)) {
        clearInterval(interval)
      } else {
        settimeToStart(difference)
      }
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  return (
    <>
      {/* Seo tags */}
      <NextSeo
        title={metaTitle || competitionsListSeo.title}
        description={metaDescription || competitionsListSeo.description}
        openGraph={{
          title: metaTitle || competitionsListSeo.title,
          description: metaDescription || competitionsListSeo.description,
          type: 'website',
          url: `https://www.codingal.com/competitions/${slug}/`,
          // eslint-disable-next-line @typescript-eslint/camelcase
          site_name: 'Codingal',
          images: [
            {
              url: ogImage || competitionDetailsPageDefaultMetaImageUrl,
              alt: `Codingal ${title}`,
            },
          ],
        }}
      />
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
        />
      </Head>
      <div className="flex flex-col h-full min-h-screen mb-10">
        <NavBar next={router.asPath} />
        <AuthModal
          isOpen={isAuthModalOpen}
          setIsOpen={setIsAuthModalOpen}
          slug={slug}
          redirectionUrl={authRedirectionUrl}
          nextRegisterRedirect={nextRegisterRedirect}
          isGradeFieldShown
          ctaText="Register now"
        />

        <div className="relative">
          {isUpcoming && (
            <div className="font-600 text-sm lg:text-base lg:absolute top-0 w-full flex">
              <div className="flex justify-center items-center mx-auto bg-orange-200 lg:bg-orange lg:bg-opacity-50 text-center py-1 px-2 lg:px-4 text-orange lg:text-white lg:rounded-md w-full lg:w-auto">
                <p className="lg:text-lg pr-3">Competition starts in</p>
                <div className="flex space-x-2 lg:space-x-3 leading-tight">
                  <div className="flex flex-col">
                    <span className="font-600 lg:text-lg">
                      {timeToStart?.days}
                    </span>
                    <span className="text-xxs text-grey-800 lg:text-grey-500 uppercase">
                      Days
                    </span>
                  </div>
                  <div className="flex flex-col" style={{ minWidth: '22px' }}>
                    <span className="font-600 lg:text-lg">
                      {timeToStart?.hours}
                    </span>
                    <span className="text-xxs text-grey-800 lg:text-grey-500 uppercase">
                      Hrs
                    </span>
                  </div>
                  <div className="flex flex-col" style={{ minWidth: '22px' }}>
                    <span className="font-600 lg:text-lg">
                      {timeToStart?.minutes}
                    </span>
                    <span className="text-xxs text-grey-800 lg:text-grey-500 uppercase">
                      Min
                    </span>
                  </div>
                  <div className="flex flex-col" style={{ minWidth: '22px' }}>
                    <span className="font-600 lg:text-lg">
                      {timeToStart?.seconds}
                    </span>
                    <span className="text-xxs text-grey-800 lg:text-grey-500 uppercase">
                      Sec
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
          {headerImage && (
            <img
              className="w-full h-auto"
              src={headerImage}
              alt={title}
              width={2880}
              height={720}
            />
          )}

          {isNormalHeader && (
            <div className="z-20 flex shadow bg-grey-50" id="normalHeader">
              <div className="container flex-wrap p-4 mx-auto md:hidden">
                <div className="flex items-center my-3">
                  <LazyAPIImage
                    className="self-center object-contain w-16 h-16 ml-5 bg-white border rounded text-grey-500"
                    src={organizer.logo}
                    alt={organizer.title}
                    width={143}
                  />
                  <div className="ml-3">
                    <h1 className="text-xl font-600 text-orange">{title}</h1>
                    <p className="text-grey">
                      Hosted by{' '}
                      <a
                        className="font-600 hover:underline"
                        href={organizer.website}
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        {organizer.title}
                      </a>
                    </p>
                  </div>
                </div>
                <div className="flex flex-col flex-wrap justify-between w-full mt-3">
                  <div className="mx-5 my-2 text-grey-800">
                    STARTS AT:
                    <p className="text-grey font-600">
                      {formatTimeByTimezone(
                        start,
                        checkedTimezone,
                        TIME_FORMAT_TZ
                      )}
                    </p>
                  </div>
                  <div className="mx-5 my-2 text-grey-800">
                    ENDS AT:
                    <p className="text-grey font-600">
                      {formatTimeByTimezone(
                        end,
                        checkedTimezone,
                        TIME_FORMAT_TZ
                      )}
                    </p>
                  </div>
                  <div className="mx-5 my-2 text-grey-800">
                    TEAM SIZE:
                    <p className="text-grey font-600">
                      {isThreeMemberTeam ? 'Upto 3 members' : '1 member'}
                    </p>
                  </div>
                  <div className="mx-5 my-2 text-grey-800">
                    LOCATION:
                    <p className="text-grey font-600">
                      {location.locationType === 'VirtualLocation'
                        ? 'Online'
                        : location.postalAddress}
                    </p>
                  </div>
                  <div className="mx-5 mb-5">
                    <CompetitionCta
                      loggedIn={loggedIn}
                      isUpcoming={isUpcoming}
                      isOngoing={isOngoing}
                      ended={ended}
                      isRegistered={isRegistered}
                      handleRegisterNow={handleRegisterNow}
                      isSubmissionDone={isSubmissionDone}
                      slug={slug}
                    />
                  </div>
                </div>
              </div>
              <div className="container flex-wrap hidden px-10 mx-auto md:flex">
                <div className="flex justify-between w-full py-5">
                  <div className="flex w-full">
                    <LazyAPIImage
                      className="self-center object-contain w-40 h-40 p-2 mx-0 my-2 bg-white border rounded text-grey-500"
                      src={organizer.logo}
                      alt={organizer.title}
                    />

                    <div className="flex flex-col w-full ml-8 my-3">
                      <h1 className="text-3xl font-600 text-orange">{title}</h1>
                      <p className="text-grey">
                        Hosted by{' '}
                        <a
                          className="font-600 hover:underline"
                          href={organizer.website}
                          rel="noreferrer noopener"
                          target="_blank"
                        >
                          {organizer.title}
                        </a>
                      </p>
                      <div className="flex w-full">
                        <div className="flex flex-wrap items-center justify-between w-10/12 mt-3">
                          <div className="my-2 text-grey-800">
                            STARTS AT:
                            <p className="text-grey font-600">
                              {formatTimeByTimezone(
                                start,
                                checkedTimezone,
                                TIME_FORMAT_TZ
                              )}
                            </p>
                          </div>
                          <div className="hidden h-full border text-grey-300 lg:block" />
                          <div className="my-2 text-grey-800">
                            ENDS AT:
                            <p className="text-grey font-600">
                              {formatTimeByTimezone(
                                end,
                                checkedTimezone,
                                TIME_FORMAT_TZ
                              )}
                            </p>
                          </div>
                          <div className="hidden h-full border text-grey-300 lg:block" />
                          <div className="my-2 text-grey-800">
                            TEAM SIZE:
                            <p className="text-grey font-600">
                              {isThreeMemberTeam
                                ? 'Upto 3 members'
                                : '1 member'}
                            </p>
                          </div>
                          <div className="hidden h-full border text-grey-300 lg:block" />
                        </div>
                        <div className="self-center w-56 ml-8">
                          <CompetitionCta
                            loggedIn={loggedIn}
                            isUpcoming={isUpcoming}
                            isOngoing={isOngoing}
                            ended={ended}
                            isRegistered={isRegistered}
                            handleRegisterNow={handleRegisterNow}
                            isSubmissionDone={isSubmissionDone}
                            slug={slug}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="sticky top-0 z-20 flex flex-col w-full">
            {isScrollHeader && (
              <div className="w-full shadow bg-grey-50" id="scrollHeader">
                <div className="container flex-wrap mx-auto lg:pl-10">
                  <div className="flex justify-between w-full py-2">
                    <div className="flex w-full">
                      <LazyAPIImage
                        className="self-center hidden object-contain w-16 h-16 p-2 m-2 bg-white border rounded md:mx-0 text-grey-500 md:block"
                        src={organizer.logo}
                        alt={organizer.title}
                      />

                      <div className="flex items-center justify-end w-full mx-3 md:mx-10 md:justify-between">
                        <h2 className="mr-10 text-xl md:text-3xl font-600 text-orange">
                          {title}
                        </h2>

                        <div className="md:w-64 md:pl-1">
                          <CompetitionCta
                            loggedIn={loggedIn}
                            isUpcoming={isUpcoming}
                            isOngoing={isOngoing}
                            ended={ended}
                            isRegistered={isRegistered}
                            handleRegisterNow={handleRegisterNow}
                            isSubmissionDone={isSubmissionDone}
                            slug={slug}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div
            className="container flex flex-wrap px-3 pb-10 mx-auto md:px-10 md:flex-no-wrap"
            id="main-container"
          >
            <div className="hidden w-40 pl-2 mt-4 mr-2 md:block">
              <div className="sticky" style={{ top: '8rem' }} id="sectionTabs">
                <div className="container flex flex-col justify-start">
                  {sections.map((section) => (
                    <a
                      key={section.slug}
                      className={`hover:text-orange font-600 leading-line leading-tight cursor-pointer mt-5 ${
                        visibleSection === section.slug
                          ? 'text-orange'
                          : 'text-grey-800'
                      }`}
                      onClick={() => handleScroll(section.slug)}
                    >
                      {section.title}
                    </a>
                  ))}
                  {/* <a
                    className={`hover:text-orange font-600 cursor-pointer mt-5 ${
                      visibleSection === COMMENTS_SECTION_REF
                        ? 'text-orange'
                        : 'text-grey-800'
                    }`}
                    onClick={() => handleScroll(COMMENTS_SECTION_REF)}
                  >
                    Comments
                    <div className="inline-block px-2 mx-1 text-sm text-white bg-orange-700 rounded-md">
                       <FastCommentsCommentCountWidget
                        tenantId={FASTCOMMENTS_TENANT_ID}
                        urlId={`competitions/${competitionId}`}
                        numberOnly
                      />
                    </div>
                  </a> */}
                </div>
              </div>
            </div>
            <div className="flex flex-col px-4 pt-1 mt-6 md:ml-6 md:w-3/5 md:px-0 max-w-full break-words">
              {sections.map((section) => (
                <Section
                  key={section.slug}
                  title={section.title}
                  id={section.slug}
                >
                  <RenderRichTextContent
                    className="max-w-screen-md text-grey"
                    content={section.content}
                    options={{
                      ADD_TAGS: ['iframe'],
                      ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder'],
                    }}
                  />
                </Section>
              ))}
              <div className="block mb-4 md:hidden">
                <div className="pt-4">
                  <QuizBanner />
                </div>
                <div className="pt-4">
                  <AlgoPhoneBanner redirectLink={ALGO_COURSES_URL} />
                </div>
              </div>

              <div className="container mx-auto" id="comments">
                <SectionTitle>Comments</SectionTitle>
                <div className="w-full mt-3">
                  <FastComments
                    uniqueUrl={`competitions/${competitionId}`}
                    loginCallback={() => {
                      setAuthRedirectionUrl(`/competitions/${slug}/`)
                      setIsAuthModalOpen(true)
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="w-56 py-8 mx-3 overflow-visible md:mx-8">
              <div className="hidden md:block">
                <h2 className="mb-3 text-xl text-grey font-600">Location</h2>
                <p className="text-grey-800">
                  {location.locationType === 'VirtualLocation'
                    ? 'Online competition'
                    : location.postalAddress}
                </p>
              </div>
              <h2 className="mt-8 mb-3 text-xl text-grey font-600">
                Share with your friends
              </h2>
              <div>
                <FacebookShareButton
                  url={competitionUrl}
                  quote={ogDescription}
                  className="mb-4 mr-4"
                >
                  <span
                    className="px-2 py-1 rounded"
                    style={{ backgroundColor: '#3c5997' }}
                  >
                    <Facebook
                      className="inline text-white"
                      size={16}
                      fill="#fff"
                      strokeWidth={0}
                    />
                  </span>
                </FacebookShareButton>
                <TwitterShareButton
                  url={competitionUrl}
                  title={metaTitle}
                  className="mb-4 mr-4"
                >
                  <span
                    className="px-2 py-1 rounded"
                    style={{ backgroundColor: '#10aced' }}
                  >
                    <Twitter
                      className="inline text-white"
                      size={16}
                      fill="#fff"
                      strokeWidth={0}
                    />
                  </span>
                </TwitterShareButton>
                <LinkedinShareButton
                  url={competitionUrl}
                  title={title}
                  summary={metaDescription}
                  source={'Codingal'}
                  className="mb-4 mr-4"
                >
                  <span
                    className="px-2 py-1 rounded"
                    style={{ backgroundColor: '#027bb6' }}
                  >
                    <Linkedin
                      className="inline text-white"
                      size={16}
                      fill="#fff"
                      strokeWidth={0}
                    />
                  </span>
                </LinkedinShareButton>
              </div>
              <div
                className={`hidden w-64 space-y-4 md:block
                ${isPaidUser && 'sticky'}`}
                style={{ top: isPaidUser && '8rem' }}
              >
                {isReferralCampaign && (
                  <ReferralBanner
                    isLoggedIn={loggedIn}
                    competitionSlug={slug}
                    handleReferralRegister={handleReferralRegister}
                  />
                )}
                {!isPaidUser && (
                  <>
                    {slug.includes('code-battle') && (
                      <AlgoLongBanner redirectLink={ALGO_COURSES_URL} />
                    )}
                  </>
                )}
              </div>
              {!isHpeCodeBattle && !isPaidUser && (
                <div className="sticky w-64 mt-4" style={{ top: '8rem' }}>
                  <CompetitionPageBanner
                    redirectLink={`${
                      loggedIn
                        ? TRIAL_CLASS_BANNER_REDIRECT_LINK.LOGGED_IN
                        : TRIAL_CLASS_BANNER_REDIRECT_LINK.LOGGED_OUT
                    }?${COMPETITION_PAGE_UTM_PARAM}`}
                  />
                </div>
              )}
              {isHpeCodeBattle && (
                <div className="sticky w-64 mt-4" style={{ top: '8rem' }}>
                  <Link
                    href="/competitions/hpe-codewars-practice-arena/"
                    prefetch={false}
                  >
                    <a className="shadow-lg rounded-lg pt-4">
                      <FastlyImage
                        src="/images/competitions/practice-arena-v3.png"
                        webpSrc="/images/competitions/practice-arena-v3.webp"
                        alt="HPE Practice Arena"
                        width={256}
                        height={338}
                      />
                    </a>
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {liveCompetitions && !isCodewars && (
        <RecommendedCompetitions
          competitionList={liveCompetitions}
          slug={slug}
        />
      )}
      <Footer />
    </>
  )
}

Competition.getInitialProps = async (context) => {
  const { competitionName } = context.query
  const token = parseCookies(context).token
  const cclientConfig = {
    method: 'GET',
    headers: {
      Authorization: token ? `Token ${token}` : null,
      'Content-Type': 'application/json',
    },
  }

  const competitionResponse = await CClient(
    `/api/v1/competitions/${competitionName}/`,
    cclientConfig
  )
  const countryCode =
    parseCookies(context)?.[USER_COUNTRY_FROM_IP_COOKIE] ||
    (await getCountryFromIP(context))
  const countryQuery = formatCountryQuery(countryCode)
  const response = await CClient(
    `/api/v1/competitions/?page_size=3&page=1&competition_type=${COMPETITION_TYPES.CODING_CONTEST}&competition_type=${COMPETITION_TYPES.HACKATHON}&state=Ongoing${countryQuery}`,
    {
      method: 'GET',
      headers: {
        Authorization: token ? `Token ${token}` : null,
        'Content-Type': 'application/json',
      },
    }
  )
  if (!competitionResponse.ok) {
    redirectToForGetInitialProps(context, `/${competitionResponse.status}/`)
    return {}
  }
  if (competitionResponse.ok) {
    const results: CompetitionEventDetailsProps = await competitionResponse.json()
    const { start, end, phases, referralCampaign } = results
    const isUpcoming = date(start).isAfter(date())
    const isOngoing = date().isBetween(start, end)
    const ended = date(end).isBefore(date())
    const isSubmissionDone =
      phases[0] &&
      phases[0].linkedEntity &&
      phases[0].linkedEntity.hasUserSubmitted
    const phaseType = phases?.[0]?.phaseType

    if (response.ok) {
      const data = await response.json()
      const categorizedCompetitions = data.results

      return {
        competitionDetails: results,
        isUpcoming,
        isOngoing,
        ended,
        isSubmissionDone,
        isReferralCampaign: referralCampaign,
        phaseType,
        liveCompetitions: categorizedCompetitions,
      }
    } else {
      return {
        competitionDetails: results,
        isUpcoming,
        isOngoing,
        ended,
        isSubmissionDone,
        isReferralCampaign: referralCampaign,
        phaseType,
        liveCompetitions: null,
      }
    }
  }
}

export default Competition
